export const TradingIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 7C2 6.44772 2.44772 6 3 6H5.16905C7.27663 6 9.22967 7.10579 10.314 8.91303L13.401 14.058C14.1239 15.2628 15.4259 16 16.831 16H19V14L22 17L19 20V18H16.831C14.7234 18 12.7703 16.8942 11.686 15.087L8.59902 9.94202C7.87613 8.7372 6.5741 8 5.16905 8H3C2.44772 8 2 7.55228 2 7Z"
        className="oui-fill-base-contrast-80"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 18C2.44772 18 2 17.5523 2 17C2 16.4477 2.44772 16 3 16H5.16905C6.5741 16 7.87613 15.2628 8.59902 14.058L9.83381 12L11 13.9437L10.314 15.087C9.22967 16.8942 7.27663 18 5.16905 18H3ZM12.1662 12L13.401 9.94202C14.1239 8.7372 15.4259 8 16.831 8H19V10L22 7L19 4V6H16.831C14.7234 6 12.7703 7.10579 11.686 8.91303L11 10.0563L12.1662 12Z"
        className="oui-fill-base-contrast-80"
      />
    </svg>
  );
};
